import Vue from 'vue';
import uniqueId from 'lodash/uniqueId';
// import './registerServiceWorker';
import router from './router';
import Client from "@/app/Http/Client";
import App from "@/App.vue";
import i18n from "@/resources/lang"
import User from "@/app/models/User";
import AuthMixin from "@/app/mixins/AuthMixin";
import ErrorsMixin from "@/app/mixins/ErrorsMixin";
import {RouteRecord} from "vue-router";
import store from "@/store";
import InProgressMixin from "@/app/mixins/InProgressMixin";
import LaravelError from "@/app/Http/concerns/LaravelError";
import {AxiosError} from "axios";
import FlashMessage from "@/app/models/FlashMessage";
import VueI18n from "vue-i18n";
//@ts-ignore
import ClickOutside from 'vue-click-outside';
//@ts-ignore
import SignaturePad from "vue-signature-pad";
import ProductType from "@/app/models/ProductType";
import Division from "@/app/models/Division";
import * as Sentry from '@sentry/vue';

Sentry.init({
    dsn: "https://ebbc2679e27fdbf6a93140ad5e5f90fb@o349358.ingest.us.sentry.io/4509485180190720",
    Vue: Vue,
    attachProps: true,
    sendDefaultPii: true
  });

Vue.config.productionTip = false;

Client.baseUrl = process.env.VUE_APP_API_URL;

Vue.directive('click-outside', ClickOutside);
Vue.mixin(AuthMixin);
Vue.mixin(ErrorsMixin);
Vue.mixin(InProgressMixin);
Vue.use(SignaturePad);

interface RootData {
    messages: FlashMessage[];
    user: User | {};
    internalServerError: AxiosError<LaravelError> | null;
}

interface RootMethods {
    $flash(message: string | VueI18n.TranslateResult, duration: number): Promise<void>;
    loadProductTypes(): Promise<void>;
    loadDivisions(): Promise<void>;
    onInternalServerError(e: AxiosError<LaravelError>): void;
}

const root = new Vue<RootData, RootMethods>({
    i18n,
    store,
    router,
    el: '#app',
    data: {
        messages: [],
        user: new User({}),
        internalServerError: null,
    },
    methods: {
        $flash(message: string | VueI18n.TranslateResult, duration: number): Promise<void> {
            // noinspection TypeScriptUnresolvedVariable
            const messages = this.messages as FlashMessage[];
            const key: string = uniqueId('message-');

            messages.push({
                key,
                message: message as string,
            });

            return new Promise(resolve => {
                setTimeout(() => {
                    // noinspection TypeScriptUnresolvedVariable
                    messages.splice(
                        messages.findIndex((m: FlashMessage) => m.key === key),
                        1
                    );
                    resolve();
                }, duration);
            })
        },
        async loadProductTypes() {
            this.$store.commit('data/setProductTypes', (await ProductType.index()).data);
        },
        async loadDivisions() {
            if (['ADMIN','SUPER_ADMIN'].includes(this.me.role as string)) {
                this.$store.commit('data/setDivisions', (await Division.index()).data);
            }
        },
        onInternalServerError(e: AxiosError<LaravelError>) {
            this.internalServerError = e;
        },
    },
    beforeMount() {
        //@ts-ignore
        this.loadProductTypes();
        //@ts-ignore
        this.loadDivisions();
    },
    render: (h) => h(App),
});

Client.onUnprocessableEntity = async (error: AxiosError<LaravelError>) => {
    root.defaultErrorHandler(error);
};
Client.onForbidden = async () => {
    const matchedRoutes = root.$route.matched;

    if (matchedRoutes.some((route: RouteRecord) => route.meta && route.meta.auth === true)) {
        await root.$router.replace({name: 'login'});
    }
};
Client.onUnauthorized = async () => {
    store.commit('auth/postLogout');
    await root.$router.replace({name: 'login'});
};
Client.onInternalServerError = async (e) => {
    root.onInternalServerError(e);
};